// LinkedIn posts mock data for EnovationWeb
// Simulating company presence since 2018

export const linkedinPosts = [
  // 2018 Posts
  {
    id: 1,
    date: '2018-12-15',
    content: '🎉 Lancement officiel d\'EnovationWeb ! Notre mission : transformer la présence digitale des entreprises tunisiennes et les accompagner vers le succès en ligne. Site web, marketing digital, SEO... nous sommes prêts ! 🚀 #AgenceDigitale #Tunisie #Innovation',
    likes: 45,
    comments: 12,
    shares: 8
  },
  {
    id: 2,
    date: '2018-12-28',
    content: '✨ Notre premier projet livré avec succès ! Un site e-commerce moderne pour une boutique locale. Fiers de contribuer à la transformation digitale de nos clients. #WebDesign #Ecommerce #DigitalTransformation',
    likes: 38,
    comments: 7,
    shares: 5
  },

  // 2019 Posts
  {
    id: 3,
    date: '2019-03-20',
    content: '📈 Les résultats parlent d\'eux-mêmes ! Notre stratégie SEO a permis à l\'un de nos clients d\'augmenter son trafic organique de +250% en 3 mois. Le référencement naturel, c\'est notre passion ! 💚 #SEO #MarketingDigital #Croissance',
    likes: 89,
    comments: 23,
    shares: 15
  },
  {
    id: 4,
    date: '2019-07-10',
    content: '🎨 Le design compte ! Découvrez notre dernière création : une interface UX/UI moderne et intuitive pour une startup fintech. L\'expérience utilisateur au cœur de nos préoccupations. #UXUI #WebDesign #Fintech',
    likes: 67,
    comments: 14,
    shares: 9
  },
  {
    id: 5,
    date: '2019-11-05',
    content: '🏆 1 an déjà ! Merci à nos 25+ clients qui nous ont fait confiance. Cette première année a été incroyable : projets variés, défis relevés, équipe agrandie. On continue ! 🚀 #Anniversaire #Milestone #Merci',
    likes: 156,
    comments: 34,
    shares: 21
  },

  // 2021 Posts
  {
    id: 6,
    date: '2021-02-18',
    content: '🤖 L\'IA au service de votre business ! Nous lançons notre nouvelle offre d\'intégration d\'intelligence artificielle : chatbots intelligents, analyse prédictive, automatisation... Le futur est maintenant ! #IA #Innovation #BusinessIntelligence',
    likes: 134,
    comments: 42,
    shares: 28
  },
  {
    id: 7,
    date: '2021-06-25',
    content: '💼 Notre équipe s\'agrandit ! Nous accueillons 5 nouveaux talents : développeurs, designers, experts marketing. Ensemble, nous sommes plus forts pour servir nos clients. Bienvenue à bord ! 🎉 #Team #Recrutement #Croissance',
    likes: 201,
    comments: 56,
    shares: 18
  },
  {
    id: 8,
    date: '2021-09-30',
    content: '📱 Le mobile d\'abord ! 75% du trafic web provient désormais du mobile. Tous nos sites sont conçus mobile-first pour une expérience optimale sur tous les écrans. #MobileFirst #ResponsiveDesign #WebDevelopment',
    likes: 98,
    comments: 19,
    shares: 12
  },
  {
    id: 9,
    date: '2021-12-10',
    content: '🎯 Cas client : Comment nous avons généré +400% de ROI publicitaire pour une marque de mode grâce à nos campagnes SEA ciblées. Le data-driven marketing fait la différence ! 📊 #SEA #GoogleAds #ROI #CasClient',
    likes: 167,
    comments: 38,
    shares: 31
  },

  // 2022 Posts
  {
    id: 10,
    date: '2022-01-15',
    content: '🌟 Bonne année 2022 ! Cette année, notre objectif : accompagner 100+ entreprises dans leur transformation digitale. Prêts à relever le défi avec vous ! 💪 #BonneAnnee #Objectifs2022 #TransformationDigitale',
    likes: 243,
    comments: 67,
    shares: 24
  },
  {
    id: 11,
    date: '2022-04-20',
    content: '🔍 Le SEO en 2022 : notre guide complet est disponible ! Algorithmes Google, Core Web Vitals, contenu de qualité... tout ce qu\'il faut savoir pour dominer les résultats de recherche. 📈 [Lien dans les commentaires] #SEO #Guide #MarketingDigital',
    likes: 189,
    comments: 45,
    shares: 52
  },
  {
    id: 12,
    date: '2022-07-08',
    content: '💚 Merci pour votre confiance ! Nous sommes fiers d\'annoncer 98% de satisfaction client et 150+ projets réussis. Votre succès est notre réussite. On continue ensemble ! 🚀 #Satisfaction #Clients #Merci',
    likes: 312,
    comments: 89,
    shares: 41
  },
  {
    id: 13,
    date: '2022-10-12',
    content: '📢 Les réseaux sociaux : un levier de croissance incontournable ! Notre équipe social media management crée du contenu viral et engage vos communautés. +300% d\'engagement moyen pour nos clients ! 🔥 #SocialMedia #CommunityManagement #Engagement',
    likes: 156,
    comments: 34,
    shares: 27
  },
  {
    id: 14,
    date: '2022-12-20',
    content: '🎄 Joyeuses fêtes de fin d\'année ! Merci pour cette année exceptionnelle. Rendez-vous en 2023 pour encore plus d\'innovation, de projets et de succès partagés ! 🌟 #Fêtes #Merci #2023',
    likes: 278,
    comments: 72,
    shares: 19
  }
];

export const companyInfo = {
  name: 'EnovationWeb',
  tagline: 'Votre partenaire digital en Tunisie',
  founded: '2018',
  employees: '20+',
  industry: 'Services Informatiques et Conseil',
  specialties: [
    'Développement Web',
    'Intelligence Artificielle',
    'Référencement SEO',
    'Publicité SEA',
    'Gestion Réseaux Sociaux',
    'Marketing Digital',
    'UX/UI Design'
  ],
  location: 'Les Berges du Lac, Tunis, Tunisie',
  website: 'www.enovationweb.com'
};
